import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { handleChange } from '../../utils/util';
import './index.scss';
import LogoHorizontal from '../../assets/logo/logo_horizontal.png';

const Form = ({
  handleSubmit, formData, form, setForm, textForms, handleClick,
  isLogin, isDNI, handleDNI, setIsLoginFormValid, isLoginFormValid
}) => {
  const [disabledButton, setDisabledButton] = useState(true);

  useEffect(() => {
    if (isDNI) {
      if (form.dni === '') setDisabledButton(true);
      else setDisabledButton(false);
    } else if ((form.identificador === '' || form.password === '')) setDisabledButton(true);
    else setDisabledButton(false);
  }, [form]);

  return (
    <div className={isLogin ? 'register-container' : 'register-container register-container-column'}>
      <h2 className="title">{textForms.title}</h2>
      <div className={isLogin ? 'form' : 'form form-column'}>
        {isLogin && <img src={LogoHorizontal} alt="CEO" className="login-image" />}
        <form onSubmit={handleSubmit}>
          {isDNI ? (
            <label key="dni" htmlFor="dni" className={isLogin ? 'label' : 'form label-column'}>
              DNI
              <input
                type="number"
                id="dni"
                className={`input ${!isLoginFormValid.dni ? 'invalid' : 'valid'}`}
                value={form.dni}
                onChange={(e) => handleChange('dni', e, form, setForm, isLoginFormValid, setIsLoginFormValid)}
              />
            </label>
          ) : (
            <div className={isLogin ? '' : 'two-columns'}>
              {formData.map((input) => (
                <label key={input.id} htmlFor={input.id} className={isLogin ? 'label' : 'label-register'}>
                  {input.text}
                  <input
                    type={input.type}
                    id={input.id}
                    className={`input ${isLoginFormValid[input.id] ? 'invalid' : 'valid'}`}
                    value={form[input.id]}
                    onChange={(e) => handleChange(
                      input.id,
                      e,
                      form,
                      setForm,
                      isLoginFormValid,
                      setIsLoginFormValid
                    )}

                  />
                </label>
              ))}

            </div>
          )}

          <div className={isLogin ? '' : 'container-button'}>
            <button
              disabled={disabledButton}
              type="submit"
              className={`${isLogin ? 'button' : 'two-column'}  ${disabledButton ? ' disabled' : 'button'}`}
            >
              {textForms.firstButton}
            </button>
          </div>
          <div className={isLogin ? '' : 'container-button'}>
            <button
              className={isLogin ? 'second-button' : 'second-button two-column'}
              onClick={handleClick}
            >
              {textForms.secondButton}

            </button>
          </div>
          {isLogin && (
            <>
              <div className={isDNI ? 'text-link-dni' : 'text-link'} role="presentation" onClick={isDNI ? () => handleDNI(false) : () => handleDNI(true)}>
                {isDNI ? 'Iniciar sesión con usuario y contraseña' : 'Ingresa sesion con DNI'}
              </div>
              {!isDNI && (
              <div className="text-link" role="presentation" onClick={() => {}}>
                Olvide mi contraseña
              </div>
              )}
            </>
          )}
        </form>
      </div>
    </div>
  );
};

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  formData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    text: PropTypes.string
  })).isRequired,
  form: PropTypes.shape({
    identificador: PropTypes.string,
    password: PropTypes.string,
    dni: PropTypes.string,
  }).isRequired,
  setForm: PropTypes.func.isRequired,
  // changeEmptyInput: PropTypes.func,
  handleClick: PropTypes.func.isRequired,
  isLogin: PropTypes.bool,
  handleDNI: PropTypes.func,
  isDNI: PropTypes.bool,
  textForms: PropTypes.shape({
    title: PropTypes.string,
    firstButton: PropTypes.string,
    secondButton: PropTypes.string,
  }).isRequired,
  setIsLoginFormValid: PropTypes.func.isRequired,
  isLoginFormValid: PropTypes.shape({
    dni: PropTypes.string,
  }).isRequired
};

Form.defaultProps = {
  isLogin: false,
  isDNI: false,
  // changeEmptyInput: () => {},
  handleDNI: () => {}
};

export default Form;
